import { useForm } from '@inertiajs/react'
import { BackofficeLayout } from '@/components/layout/BackofficeLayout'
import { FormSection } from '@/components/backoffice/FormSection'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'

type Props = {
  country: { id: string; code: string; name: string }
  state: { id: string; code: string; name: string }
  local_area: { id: string; code: string; name: string }
}

export default function LocalAreasEdit({ country, state, local_area }: Props) {
  const { data, setData, patch, processing, errors } = useForm({ code: local_area.code, name: local_area.name })

  return (
    <BackofficeLayout title={`Edit ${local_area.name}`} breadcrumbs={[{ label: 'Backoffice', href: '/backoffice/dashboard' }, { label: 'Jurisdictions', href: '/backoffice/countries' }, { label: country.name, href: `/backoffice/countries/${country.id}` }, { label: state.name, href: `/backoffice/countries/${country.id}/states/${state.id}` }, { label: 'Edit' }]}>
      <div className="space-y-6">
        <div className="mb-8">
          <h1 className="text-xl font-semibold tracking-tight">Edit {local_area.name}</h1>
        </div>
        <form onSubmit={e => { e.preventDefault(); patch(`/backoffice/countries/${country.id}/states/${state.id}/local_areas/${local_area.id}`) }} className="max-w-sm space-y-6">
          <FormSection>
            <div className="space-y-3">
              <div className="space-y-1.5">
                <label className="text-[12px] font-medium text-muted-foreground uppercase tracking-wider">Code</label>
                <Input className="h-8 text-sm" value={data.code} onChange={e => setData('code', e.target.value)} />
                {errors.code && <p className="text-[12px] text-destructive">{errors.code}</p>}
              </div>
              <div className="space-y-1.5">
                <label className="text-[12px] font-medium text-muted-foreground uppercase tracking-wider">Name</label>
                <Input className="h-8 text-sm" value={data.name} onChange={e => setData('name', e.target.value)} />
                {errors.name && <p className="text-[12px] text-destructive">{errors.name}</p>}
              </div>
            </div>
          </FormSection>
          <div className="flex gap-2">
            <Button type="submit" size="sm" disabled={processing} className="h-8 text-[13px]">Save Changes</Button>
            <Button type="button" size="sm" variant="ghost" onClick={() => window.history.back()} className="h-8 text-[13px]">Cancel</Button>
          </div>
        </form>
      </div>
    </BackofficeLayout>
  )
}
